import React from "react";
import SiteHeader from "../SiteHeader/SiteHeader";

import { RootState } from '../../store/store'
import { useSelector } from 'react-redux'

const Welcome = (): JSX.Element => {
    const FirstName: string = useSelector((state: RootState) => state.participant.firstName)
    const LastName: string = useSelector((state: RootState) => state.participant.lastName)

    return <SiteHeader showText={"Herzlich willkommen " + FirstName + " " + LastName}></SiteHeader>
}

export default Welcome;